import React from "react";
import { Box } from "@chakra-ui/react";
import { TextTitle } from "ui/text";
import { WarehouseNameRotation } from "components/animations/warehouse-name-rotation";
import { ProductFeatures, type ProductFeature } from "ui/product-features";
import { HightouchCdpDiagram } from "components/animations/hightouch-cdp-diagram";
import firstMobileImage from "../../../../public/assets/platform/composable-cdp/mobile-diagram-1.png";
import secondMobileImage from "../../../../public/assets/platform/composable-cdp/mobile-diagram-2.png";
import thirdMobileImage from "../../../../public/assets/platform/composable-cdp/mobile-diagram-3.png";
import { integrationsCount } from "../../../constants/integrations";

const cdpFeatures: ProductFeature[] = [
  {
    id: "collect-data",
    title: "Collect data directly into your data warehouse",
    description:
      "Hightouch Events allows you to collect any web or server side event by simply implementing a few lines of code.",
    cta: { label: "Explore Hightouch Events", href: "/platform/events", variant: "primary" },
    mobileImage: {
      src: firstMobileImage,
      alt: "Abstract illustration of data getting collected with Hightouch Events.",
    },
  },
  {
    id: "analyze-data",
    title: "Analyze and organize your data into a single source of truth",
    description:
      "Hightouch Identity Resolution allows you to define your own rules and own your identity graph yourself.",
    cta: { label: "Explore Identity Resolution", href: "/platform/identity-resolution", variant: "primary" },
    mobileImage: {
      src: secondMobileImage,
      alt: "Abstract illustration of data getting analyzed and organized with Hightouch Identity Resolution.",
    },
  },
  {
    id: "activate-data",
    title: "Activate any type of data to power any use case",
    description:
      "Hightouch Customer Studio allows you to build audiences or traits using all of the data in your warehouse.",
    cta: { label: "Explore Customer Studio", href: "/platform/customer-studio", variant: "primary" },
    mobileImage: {
      src: thirdMobileImage,
      alt: `Abstract illustration of data getting activated into ${integrationsCount}+ tools with Hightouch Customer Studio.`,
    },
  },
];

export function CdpDiagram() {
  return (
    <Box>
      <TextTitle
        align="center"
        size="lg"
        theme="dark"
        maxW="640px"
        title={
          <>
            Deliver your Customer Data Platform on <WarehouseNameRotation />
          </>
        }
        description="Don’t copy your data to an incompatible and less secure data silo. Turn your existing data into a CDP instead."
      />

      <ProductFeatures
        mt={{ base: "biggest", md: "huge" }}
        theme="dark"
        productFeatures={cdpFeatures}
        media={<HightouchCdpDiagram />}
      />
    </Box>
  );
}
